import { FormControlLabel, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Check, X } from 'lucide-react'
import React from 'react'
import { C1Checkbox, C1CheckboxProps } from './C1Checkbox'
import { C1CheckboxPrettyDisplayStyles } from './styles'

const DisplayOnly = ({ checked }: { checked: boolean }): React.ReactElement => (
    checked
        ? <C1Icon
            icon={Check}
            data-testid="checkbox-display-only-icon"
            aria-hidden="true"
            sx={{ ...C1CheckboxPrettyDisplayStyles.icon, color: 'success.main' }}
        />
        : <C1Icon
            icon={X}
            data-testid="checkbox-display-only-icon"
            aria-hidden="true"
            sx={{ ...C1CheckboxPrettyDisplayStyles.icon, color: 'error.main' }}
        />
)

export const C1CheckboxPrettyDisplay = ({
    checked = false,
    id,
    label,
    disabled,
    ...props
}: C1CheckboxProps): React.ReactElement => (
    disabled
        ? <FormControlLabel
            key={id}
            control={
                <div role="checkbox" aria-checked={checked} aria-disabled="true">
                    <DisplayOnly checked={checked} />
                </div>
            }
            label={<Typography>{label}</Typography>}
            disabled={disabled}
        />
        : <C1Checkbox id={id} label={label} checked={checked} {...props} />
)
